import apiClient from "../lib/api-client";

export interface PermissionRecord {
  id: string;
  key: string;
  group: string;
  description?: string | null;
}

export interface RoleRecord {
  id: string;
  name: string;
  description?: string | null;
  isSystem: boolean;
  tenantId?: string | null;
  permissions: string[];
}

export interface RolePayload {
  name: string;
  description?: string | null;
  tenantId?: string | null;
  permissions?: string[];
}

export interface RoleUpdatePayload {
  name?: string;
  description?: string | null;
  permissions?: string[];
}

class RbacService {
  async getPermissions(): Promise<PermissionRecord[]> {
    const response = await apiClient.get("/rbac/permissions");
    return response.data;
  }

  async getRoles(tenantId?: string): Promise<RoleRecord[]> {
    const response = await apiClient.get("/rbac/roles", {
      params: tenantId ? { tenantId } : undefined,
    });
    return response.data;
  }

  async createRole(payload: RolePayload): Promise<RoleRecord> {
    const response = await apiClient.post("/rbac/roles", payload);
    return response.data;
  }

  async updateRole(
    roleId: string,
    payload: RoleUpdatePayload,
  ): Promise<RoleRecord> {
    const response = await apiClient.patch(`/rbac/roles/${roleId}`, payload);
    return response.data;
  }

  async deleteRole(roleId: string): Promise<{ success: boolean }> {
    const response = await apiClient.delete(`/rbac/roles/${roleId}`);
    return response.data;
  }
}

export const rbacService = new RbacService();
